/**
 * Safe wrappers around the native Popover API.
 *
 * They guard against two failure modes observed in production:
 *
 * - Disconnected element race (LUCID-28743 / LUCID-29872): the popover element
 *   is detached from the DOM (e.g. during an unmount/remount) before the call
 *   runs. Native `showPopover()` / `hidePopover()` throw `InvalidStateError`
 *   on a disconnected element.
 * - Missing Popover API (LUCID-29873): browsers below our baseline (notably
 *   Safari < 17) have no Popover API, so the method is `undefined`. The
 *   WebClient loads a polyfill for those browsers, but feature-detecting here
 *   keeps these helpers safe regardless of load order or environment (tests,
 *   SSR-like contexts, etc.).
 */
export const safeShowPopover = (element) => {
    if (element?.isConnected && typeof element.showPopover === 'function') {
        element.showPopover();
    }
};
export const safeHidePopover = (element) => {
    if (element?.isConnected && typeof element.hidePopover === 'function') {
        element.hidePopover();
    }
};
